module.exports = __webpack_public_path__ + "img/RBPerdigao.bee8cc42.png";